import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.find";
import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* eslint-disable */
/* 日历弹框组件
 * ticket={  //初始化，定义一个vue对象属性
 * type:1,  //1(门票预订单选日历)、2(二次预约单选日历)、3(在线预约单选日历)、4(在线预约多选日历)、5(客房日历)、6(预约库存，以下参数都不需要)、7(二次预约多选日历)、8(酒店日历)、9(其它项目日历)(必带，int类型) ,
 * buyNum:1, //用户购买数(type==8不用带，其他类型带，int类型),
 * minNum:1, //最小购买数(type==1、5时带，int类型),
 * alldayList:[],  //存放生成的日历对象列表(type==1、4、5、7、8、9时带，array类型),
 * selectDate:{},  //选择的日历对象(type==1、2、3、9时带，object类型),
 * tempSelectDate:{},  //临时选中的日历对象(type==1、2、3、9时带，object类型),
 * selectStartDate:{},  //入住日历对象(type==4、5、7、8时带，object类型),
 * selectEndDate:{},  //离店日历对象(type==4、5、7、8时带，object类型),
 * tempStartDate:{},  //临时保存入住日历对象(type==4、5、7、8时带，object类型),
 * tempEndDate:{},  //临时保存离店日历对象(type==4、5、7、8时带，object类型),
 * useDate:[],  //接口返回来的日历数据(type==8时设置空数组即可，array类型)
 * }
 *
 * //生成日历，初始化日历数据  startDate(开始日期) endDate(结束日期) useDate(接口返回来的日历对象列表) type==8时，无需传startDate、endDate、useDate参数
 * this.ticket.useDate=componentCenter.ticketCalendar.calendar(this.ticket, startDate, endDate, useDate)
 * componentCenter.ticketCalendar.seclectInOutDayByDate("2019-07-17", "2019-07-25") //多选日历选择指定入离日期，不传指定日期默认选中今日和明日
 * componentCenter.ticketCalendar.loadCalendar(confirmCallback, cancelCallback) //加载并弹出日历框  confirmCallback(点击确认按钮的回调函数，非必传) cancelCallback(点击取消选择按钮的回调函数，非必传)
 * componentCenter.ticketCalendar.viewReserveStock() //查看预约库存
 *
 * //父组件mounted方法里需要执行代码（处理hash值、监控hash值变化隐藏日历弹框）
 * location.hash == "#calendar" && history.go(-1);
 * window.onhashchange = function() {
 * 		if(!location.hash){ //根据具体情况设置条件
 * 			componentCenter.ticketCalendar.showCalendar && componentCenter.ticketCalendar.slideDownCalendar();
 * 		}
 * }
 */
import { toast as _toast, hideToast, showLoading, hideLoading } from "@ykz/ykz-util/base";
import databus, { Origins } from "@ykz/ykz-http/core";
export default {
  name: "ticketCalendar",
  data: function data() {
    return {
      showCalendar: false,
      //显示日历
      calendarSlideDown: true,
      //日历弹框是否滑下，默认true
      ticket: {},
      //存放显示日历的产品对象
      projectList: [],
      //存放预约项目列表
      selectProject: {},
      //选中的预约项目
      confirmCallback: function confirmCallback() {},
      //点击确认按钮触发的回调函数
      cancelCallback: function cancelCallback() {},
      //点击取消选择触发的回调函数
      stickyMonth: ""
    };
  },
  props: {
    useRef: {},
    //针对type==9类型的日历，会传useRef属性，防止父组件的componentCenter.ticketCalendar被覆盖
    isPickUp: {} //发货日期日历样式
  },

  mounted: function mounted() {
    if (!this.useRef) {
      _typeof(window.componentCenter) == "object" || (window.componentCenter = {});
      window.componentCenter.ticketCalendar = this;
    } else {
      this.$watch("showCalendar", function (val) {
        //兼容ios的内核浏览器
        if (val) {
          $(".scroll-area").css("overflow-y", "hidden");
        } else {
          $(".scroll-area").css("overflow-y", "");
        }
      });
    }
    console.log("ycf组件初始化：ticketCalendar");
  },
  methods: {
    //toast
    toast: function toast(str, millisecond) {
      _toast(str, millisecond || 2000);
    },
    //查看预约库存，产品详情页调用
    viewReserveStock: function viewReserveStock(goodId, isPage, skuId) {
      if (this.ticket.type == 6) {
        this.slideUpCalendar();
        return true;
      }
      var that = this;
      databus({
        url: "/apiv2/newbook/viewInventory",
        type: "get",
        data: {
          goodId: +goodId,
          skuId: skuId || "",
          apiVersion: 1 //有值表示拿新数据结构
        },

        success: function success(res) {
          if (res.code == 1000 && res.bcode == 100) {
            that.projectList = res.content || [];
            that.ticket.type = 6;
            that.ticket.isPage = isPage || false; //展示页面模式
            var isHasCalendar = false;
            for (var i in that.projectList) {
              if (that.projectList[i].stockNum && that.projectList[i].useDate && that.projectList[i].useDate.length) {
                that.selectReserveProject(that.projectList[i]);
                isHasCalendar = true;
                break;
              }
            }
            !isHasCalendar && that.selectReserveProject(that.projectList[0] || {}, true);
            that.$nextTick(function () {
              that.slideUpCalendar(function () {
                if (that.projectList[0] && that.projectList[0].projectName || that.ticket.isPage) {
                  that.$nextTick(function () {
                    $(".component-ticket-calendar").each(function () {
                      $(this).find(".main-bottom").css("border-radius", "0");
                      $(this).find(".calendar-scroll").css({
                        height: window.innerHeight - $(this).find(".view-stock-head").height() - $(this).find(".project-content").height() - $(this).find(".calendar-week").outerHeight()
                      });
                      $(this).find(".project-scroll").each(function () {
                        if (this.scrollTop + this.offsetHeight == this.scrollHeight) {
                          $(this).parent().addClass("hide-mask");
                        } else {
                          $(this).scroll(function () {
                            if (this.scrollTop + this.offsetHeight >= this.scrollHeight) {
                              $(this).parent().addClass("hide-mask");
                            } else {
                              $(this).parent().removeClass("hide-mask");
                            }
                          });
                        }
                      });
                    });
                  });
                }
              });
            });
          } else {
            that.toast(res.message || "预约库存获取失败！");
          }
        },
        error: function error() {
          isPage && that.toast("网络异常，请刷新页面重试！");
        },
        beforeSend: function beforeSend() {
          !isPage && showLoading({
            cover: true,
            opacity: 0
          });
        },
        complete: function complete() {
          hideLoading();
        }
      });
    },
    //选择预约项目
    selectReserveProject: function selectReserveProject(project, isDefault) {
      if (!isDefault && (!project.stockNum || !project.useDate || !project.useDate.length)) {
        return false;
      }
      this.selectProject = project;

      //初始化或重置日历
      var startDate = "",
        endDate = "",
        ticket = {
          type: 6,
          //类型6的日历弹框
          isPage: this.ticket.isPage,
          //true：页面模式    false：弹框模式
          selectDate: {},
          //用户点击的日历对象
          useDate: [] //存放日历数据
        };

      if (project.useDate && project.useDate.length) {
        startDate = project.useDate[0].sellDate;
        endDate = project.useDate[project.useDate.length - 1].sellDate;
      }
      ticket.useDate = this.calendar(ticket, startDate, endDate, project.useDate || []);
      this.ticket = ticket;
    },
    //向上滑动显示日历弹框
    slideUpCalendar: function slideUpCalendar(callback) {
      if (this.ticket.type != 6) {
        if (this.ticket.selectDate) {
          this.ticket.tempSelectDate = this.ticket.selectDate;
        } else {
          this.ticket.tempStartDate = this.ticket.selectStartDate;
          this.ticket.tempEndDate = this.ticket.selectEndDate;
        }
      } else if (this.ticket.isPage) {
        this.showCalendar = true;
        this.calendarSlideDown = false;
        typeof callback == "function" && callback();
        return;
      }
      this.showCalendar = true;
      var that = this;
      setTimeout(function () {
        that.calendarSlideDown = false;
        if (!(that.ticket.type == 1 && !that.ticket.selectDate.sellDate || that.ticket.type == 5 && !that.ticket.selectEndDate.sellDate)) {
          location.hash != "#calendar" && (location.hash = "calendar");
        }
        if (typeof callback == "function") {
          setTimeout(function () {
            callback(); //ios在微信内置浏览器上，有底部导航栏会改变页面高度
          }, 50);
        }
        that.$nextTick(function () {
          var firstItem = that.ticket.alldayList.find(function (v) {
            return v.disabled == false;
          });
          if (firstItem) {
            var firstItemOffset = $("." + firstItem.sellDate).offset().top;
            var calendarWeekOffset = $(".calendar-week").offset().top + $(".calendar-week").height() + $('.month').innerHeight() + 2;
            var distance = firstItemOffset - calendarWeekOffset;
            $(".calendar-scroll").scrollTop(distance);
          }
        });
      }, 30);
    },
    //向下滑动隐藏日历弹框
    slideDownCalendar: function slideDownCalendar(callback) {
      if (this.ticket.type == 1 && !this.ticket.selectDate.sellDate) {
        if (!this.ticket.tempSelectDate.sellDate) {
          this.toast("请先选择使用日期");
          return false;
        }
        this.toast("请点击确定按钮");
        return false;
      }
      if (this.ticket.type == 5 && !this.ticket.selectEndDate.sellDate) {
        if (!this.ticket.tempStartDate.sellDate) {
          this.toast("请先选择入离日期");
          return false;
        }
        if (!this.ticket.tempEndDate.sellDate) {
          this.toast("请选择离店日期");
          return false;
        }
        this.toast("请点击确定按钮");
        return false;
      }
      this.calendarSlideDown = true;
      var that = this;
      setTimeout(function () {
        that.showCalendar = false;
        location.hash == "#calendar" && history.go(-1);
        typeof callback == "function" && callback();
      }, 300);
      $(".calendar-scroll").scrollTop(0);
    },
    //加载并弹出日历
    loadCalendar: function loadCalendar(confirmCallback, cancelCallback) {
      this.slideUpCalendar();
      if (typeof confirmCallback == "function" && this.confirmCallback != confirmCallback) {
        this.confirmCallback = confirmCallback;
      }
      if (typeof cancelCallback == "function" && this.cancelCallback != cancelCallback) {
        this.cancelCallback = cancelCallback;
      }
    },
    //选择日期
    selectDay: function selectDay(ticket, day) {
      var _this = this;
      if (ticket.type == 1 || ticket.type == 2 || ticket.type == 3 || ticket.type == 9) {
        if (day.isBook != 1 || !day.stockNum) {
          return false;
        }
        if (ticket.type == 1) {
          if (ticket.minNum > day.stockNum) {
            return false;
          }
          if (day.stockNum < ticket.buyNum) {
            this.toast("当天最多可购买" + day.stockNum + "份");
          }
        }
        if ((ticket.type == 2 || ticket.type == 9) && ticket.buyNum > day.stockNum) {
          return false;
        }
        if (ticket.type == 3 && ticket.buyNum > day.stockNum) {
          this.toast("该日期库存不足");
          return false;
        }
        ticket.tempSelectDate = day;
      } else if (ticket.type == 4 || ticket.type == 5) {
        if (ticket.type == 5 && ticket.hasElement) {
          this.selectInDayAutoOutDay(ticket, day);
        } else {
          this.seclectInOutDay(ticket, day);
        }
      } else if (ticket.type == 6) {
        if (day.isBook == 1 && day.stockNum > 0) {
          ticket.selectDate = ticket.selectDate == day ? {} : day;
        }
      } else if (ticket.type == 7) {
        this.selectInDayAutoOutDay(ticket, day);
      } else if (ticket.type == 8) {
        this.seclectHotelInOutDay(ticket, day);
      } else {
        //还未定义的日历弹框类型
      }

      // 直接调用确认按钮
      this.$nextTick(function () {
        _this.clickConfirmBtn(ticket);
      });
    },
    //选择入住离店日期
    seclectInOutDay: function seclectInOutDay(ticket, day, notToast) {
      ticket.type == 5 && (ticket.buyNum = ticket.minNum);
      if (!ticket.tempStartDate.sellDate) {
        if (day.isBook == 1) {
          if (ticket.buyNum > day.stockNum) {
            !notToast && this.toast("该日期库存不足");
            return false;
          }
          ticket.tempStartDate = day;
          !notToast && hideToast(); //清除toast提示
          return true;
        } else {
          return false;
        }
      }
      if (ticket.tempStartDate.sellDate && !ticket.tempEndDate.sellDate) {
        if (day.isBook == 1 && day.index <= ticket.tempStartDate.index) {
          if (ticket.buyNum > day.stockNum) {
            !notToast && this.toast("该日期库存不足");
            return false;
          }
          ticket.tempStartDate = day;
          !notToast && hideToast(); //清除toast提示
          return true;
        }
        if (day.index < ticket.tempStartDate.index && day.isBook != 1) {
          return false;
        }
        if (day.index > ticket.tempStartDate.index + 1) {
          for (var i = ticket.tempStartDate.index + 1; i < day.index; i++) {
            if (ticket.alldayList[i].isBook != 1 || ticket.alldayList[i].stockNum < ticket.buyNum) {
              if (day.isBook == 1) {
                if (ticket.buyNum > day.stockNum) {
                  !notToast && this.toast("该日期库存不足");
                  return false;
                }
                ticket.tempStartDate = day;
                !notToast && hideToast(); //清除toast提示
                return true;
              } else {
                return false;
              }
            }
          }
        }
        if (ticket.type == 4 && (day.index - ticket.tempStartDate.index) * ticket.buyNum > ticket.ticketNum) {
          !notToast && !day.disabled && this.toast("入住天数乘以预约数量不能大于券号个数");
          if (day.isBook == 1 && day.stockNum >= ticket.buyNum) {
            ticket.tempStartDate = day;
          }
          return false;
        }
        if (ticket.type == 5) {
          var stayDays = day.index - ticket.tempStartDate.index;
          if (ticket.minNights > stayDays) {
            !notToast && !day.disabled && this.toast("该商品最少需连续入住" + ticket.minNights + "晚");
            if (day.isBook == 1 && day.stockNum >= ticket.buyNum) {
              ticket.tempStartDate = day;
            }
            return false;
          }
          if (stayDays % ticket.baseValueNights != 0) {
            !notToast && !day.disabled && this.toast("该商品预订基准数是" + ticket.baseValueNights + "晚，预订晚数请选择" + ticket.baseValueNights + "的倍数");
            if (day.isBook == 1 && day.stockNum >= ticket.buyNum) {
              ticket.tempStartDate = day;
            }
            return false;
          }
          if (stayDays > ticket.maxNights && ticket.maxNights != -1) {
            !notToast && !day.disabled && this.toast("该商品最多能连续入住" + ticket.maxNights + "晚");
            if (day.isBook == 1 && day.stockNum >= ticket.buyNum) {
              ticket.tempStartDate = day;
            }
            return false;
          }
        }
        ticket.tempEndDate = day;
        !notToast && hideToast(); //清除toast提示
        return true;
      }
      if (ticket.tempStartDate.sellDate && ticket.tempEndDate.sellDate) {
        if (day.isBook == 1) {
          if (ticket.buyNum > day.stockNum) {
            !notToast && this.toast("该日期库存不足");
            return false;
          }
          ticket.tempStartDate = day;
          ticket.tempEndDate = {};
          !notToast && hideToast(); //清除toast提示
        } else {
          return false;
        }
      }
    },
    //通过传参选择指定入离日期，有库存晚数检验，checkInTime、checkOutTime：“2019-08-01”，callback：选择成功后的回调函数
    selectInOutDayByTime: function selectInOutDayByTime(checkInTime, checkOutTime, callback) {
      if (checkInTime && checkOutTime && typeof checkInTime == "string" && typeof checkOutTime == "string") {
        for (var i in this.ticket.alldayList) {
          var day = this.ticket.alldayList[i];
          if (checkInTime == day.sellDate) {
            this.seclectInOutDay(this.ticket, day, "不要toast");
            continue;
          }
          if (checkOutTime == day.sellDate) {
            this.seclectInOutDay(this.ticket, day, "不要toast");
            break;
          }
        }
        if (this.ticket.tempStartDate.sellDate && this.ticket.tempEndDate.sellDate) {
          this.ticket.selectStartDate = this.ticket.tempStartDate;
          this.ticket.selectEndDate = this.ticket.tempEndDate;
          typeof callback == "function" && callback();
          return true;
        } else {
          this.ticket.tempStartDate = {};
          this.ticket.tempEndDate = {};
        }
      }
      return false;
    },
    //选中入住日期自动选择离店日期
    selectInDayAutoOutDay: function selectInDayAutoOutDay(ticket, day) {
      if (ticket.buyNum > day.stockNum || day.isBook != 1) return false;
      var tempDay = {},
        i = 0;
      if (!ticket.alldayList[day.index + ticket.stayDays]) {
        this.toast("入住晚数不足，请重新选择入住日期！", 3000);
        return false;
      }
      for (i = 1; i < ticket.stayDays; i++) {
        tempDay = ticket.alldayList[day.index + i];
        if (tempDay.isBook == 0 || tempDay.isBook == -1) {
          this.toast("入住和离店期间存在不可预订的日期，请重新选择入住日期！", 4000);
          return false;
        }
        if (tempDay.isBook == 2 || tempDay.stockNum == 0) {
          this.toast("入住和离店期间存在已" + (ticket.type == 5 ? "售罄" : "约满") + "的日期，请重新选择入住日期！", 4000);
          return false;
        }
      }
      for (i = 1; i < ticket.stayDays; i++) {
        tempDay = ticket.alldayList[day.index + i];
        if (tempDay.stockNum < ticket.buyNum) {
          this.toast("入住和离店期间存在库存不足的日期，请重新选择入住日期" + (ticket.type == 5 ? "" : "或调整预约数量") + "！", ticket.type == 5 ? 4000 : 5000);
          return false;
        }
      }
      hideToast(); //清除toast提示
      ticket.tempStartDate = day;
      ticket.tempEndDate = ticket.alldayList[day.index + ticket.stayDays];
    },
    //选择酒店的入住离店日期
    seclectHotelInOutDay: function seclectHotelInOutDay(ticket, day) {
      if (!ticket.tempStartDate.sellDate) {
        if (day.isBook == 1) {
          ticket.tempStartDate = day;
          return true;
        } else {
          return false;
        }
      }
      if (ticket.tempStartDate.sellDate && !ticket.tempEndDate.sellDate) {
        if (day.isBook == 1 && day.index <= ticket.tempStartDate.index) {
          ticket.tempStartDate = day;
          return true;
        }
        if (day.index < ticket.tempStartDate.index && day.isBook != 1) {
          return false;
        }
        if (day.index > ticket.tempStartDate.index + 1) {
          for (var i = ticket.tempStartDate.index + 1; i < day.index; i++) {
            if (ticket.alldayList[i].isBook != 1) {
              if (day.isBook == 1) {
                ticket.tempStartDate = day;
                return true;
              } else {
                return false;
              }
            }
          }
        }
        ticket.tempEndDate = day;
        return true;
      }
      if (ticket.tempStartDate.sellDate && ticket.tempEndDate.sellDate) {
        if (day.isBook == 1) {
          ticket.tempStartDate = day;
          ticket.tempEndDate = {};
        } else {
          return false;
        }
      }
    },
    //选择指定入离日期，无库存晚数检验，startDate、endDate：“2019-08-01”
    seclectInOutDayByDate: function seclectInOutDayByDate(startDate, endDate) {
      var ticket = this.ticket,
        tempStartDate = {},
        i = 0,
        tempEndDate = {};
      if (startDate && endDate) {
        for (i in ticket.alldayList) {
          if (startDate == ticket.alldayList[i].sellDate) {
            tempStartDate = ticket.alldayList[i];
          }
          if (endDate == ticket.alldayList[i].sellDate) {
            tempEndDate = ticket.alldayList[i];
          }
          if (tempStartDate.sellDate && tempEndDate.sellDate) {
            break;
          }
        }
        if (tempStartDate.sellDate && tempEndDate.sellDate) {
          for (i = tempStartDate.index; i < tempEndDate.index; i++) {
            if (ticket.alldayList[i].isBook != 1) {
              tempStartDate = {};
              tempEndDate = {};
              break;
            }
          }
        } else {
          tempStartDate = {};
          tempEndDate = {};
        }
      }
      if (!(tempStartDate.sellDate && tempEndDate.sellDate)) {
        for (i in ticket.alldayList) {
          if (ticket.alldayList[i].dateStr == "今日" && ticket.alldayList[i].isBook == 1) {
            tempStartDate = ticket.alldayList[i];
            tempEndDate = ticket.alldayList[+i + 1] || {};
            break;
          }
        }
        if (!(tempStartDate.sellDate && tempEndDate.sellDate)) {
          for (i in ticket.alldayList) {
            if (ticket.alldayList[i].isBook == 1) {
              tempStartDate = ticket.alldayList[i];
              tempEndDate = ticket.alldayList[+i + 1] || {};
              break;
            }
          }
        }
      }
      if (tempStartDate.sellDate && tempEndDate.sellDate) {
        ticket.selectStartDate = tempStartDate;
        ticket.selectEndDate = tempEndDate;
      }
    },
    //取消多选日历的选择
    cancelSelected: function cancelSelected(ticket) {
      if (!ticket.selectStartDate.sellDate) {
        this.slideDownCalendar();
      } else {
        ticket.selectStartDate = {};
        ticket.selectEndDate = {};
        this.slideDownCalendar(this.cancelCallback);
      }
    },
    //点击日历确定按钮
    clickConfirmBtn: function clickConfirmBtn(ticket) {
      if (ticket.tempStartDate && ticket.tempEndDate) {
        if (!ticket.tempStartDate.sellDate) {
          this.toast(ticket.type == 7 ? "请选择入住日期" : "请选择入离日期");
          return false;
        }
        if (!ticket.tempEndDate.sellDate) {
          this.toast("请选择离店日期");
          return false;
        }
        if (ticket.selectStartDate != ticket.tempStartDate || ticket.selectEndDate != ticket.tempEndDate) {
          ticket.selectStartDate = ticket.tempStartDate;
          ticket.selectEndDate = ticket.tempEndDate;
          this.confirmCallback(ticket);
        }
      } else {
        if (!ticket.tempSelectDate.sellDate) {
          this.toast("请选择使用日期");
          return false;
        }
        if (ticket.selectDate != ticket.tempSelectDate) {
          ticket.selectDate = ticket.tempSelectDate;
          this.confirmCallback(ticket);
        }
      }
      this.slideDownCalendar();
    },
    //获取日历置灰（不可选）状态
    getDisabled: function getDisabled(ticket, day) {
      day.disabled = returnDisabled();
      return day.disabled;
      function returnDisabled() {
        var disabled = false;
        if (day.isBook != 1 || !day.stockNum) {
          disabled = true;
        }
        if (ticket.type == 1 && ticket.minNum > day.stockNum) {
          disabled = true;
        }
        if ((ticket.type == 2 || ticket.type == 7 || ticket.type == 9) && ticket.buyNum > day.stockNum) {
          disabled = true;
        }
        if (disabled && ticket.tempStartDate && ticket.tempStartDate.sellDate && ticket.tempEndDate && !ticket.tempEndDate.sellDate && day.index > ticket.tempStartDate.index) {
          if (ticket.type == 4 && (day.index - ticket.tempStartDate.index) * ticket.buyNum > ticket.ticketNum) {
            return disabled;
          }
          if (ticket.type == 5) {
            var stayDays = day.index - ticket.tempStartDate.index;
            if (ticket.minNights > stayDays) {
              return disabled;
            }
            if (stayDays % ticket.baseValueNights != 0) {
              return disabled;
            }
            if (stayDays > ticket.maxNights && ticket.maxNights != -1) {
              return disabled;
            }
          }
          for (var i = ticket.tempStartDate.index + 1; i < day.index; i++) {
            var tempDay = ticket.alldayList[i];
            if (tempDay.isBook != 1 || !tempDay.stockNum || ticket.type == 7 && ticket.buyNum > tempDay.stockNum) {
              return disabled;
            }
          }
          disabled = false;
        }
        return disabled;
      }
    },
    //获取年月日，参数str:"2019-07-01"     type("year-month":return 2019-08   "month-day":return 10月1日)
    getYearMonth: function getYearMonth(str, type) {
      if (typeof str != "string") {
        return "";
      }
      var arrStr = str.split("-");
      if (type == "year-month") {
        return arrStr[0] + "-" + arrStr[1]; //2019-08
      }

      if (type == "month-day") {
        return +arrStr[1] + "月" + +arrStr[2] + "日"; //10月1日
      }
    },

    //获取空白格的数量
    getBlankSpaceNum: function getBlankSpaceNum(str) {
      var date = new Date(str);
      return date.getDay();
    },
    //生成日历 startDate(开始日期) endDate(结束日期)  useDate(接口返回来的日历对象列表)
    calendar: function calendar(ticket, startDate, endDate, useDate) {
      //避免多个日历共用地址指针
      if (ticket.type == 9 && useDate instanceof Array) {
        useDate = JSON.parse(JSON.stringify(useDate));
      }

      //多选日历补日期(酒店日历不需要补)
      if (ticket.type != 8 && ticket.selectStartDate && ticket.selectEndDate) {
        if (endDate && useDate && useDate.length && useDate[useDate.length - 1].isBook == 1 && useDate[useDate.length - 1].stockNum > 0) {
          var nextDayObj = getDateObj(new Date(endDate).getTime() + 24 * 60 * 60 * 1000);
          endDate = formatDate(nextDayObj.year, nextDayObj.month, nextDayObj.day, "-");
        }
      }
      this.ticket = ticket;
      var startObj = getDateObj(startDate),
        endObj = getDateObj(endDate),
        monthList = [],
        isHasToday = false,
        index = 0,
        count = 0,
        i = 0,
        todayIndex = 0;
      if (ticket.type == 8) {
        useDate = [];
        var tempYear = startObj.year,
          //两个月以后的年份
          tempMonth = startObj.month + 8; //两个月以后的月份
        if (tempMonth > 12) {
          tempYear++;
          tempMonth -= 12;
        }
        endObj = getDateObj(formatDate(tempYear, tempMonth, 1, "-"));
      }

      //dateStr字段（今日、明日的特殊处理）
      if (ticket.type != 6) {
        for (i in useDate) {
          if (useDate[i].dateStr == "今日") {
            isHasToday = true;
            break;
          }
        }
        if (!isHasToday) {
          var todayObj = getDateObj(),
            tomorrowObj = getDateObj(new Date().getTime() + 24 * 60 * 60 * 1000),
            todayDate = formatDate(todayObj.year, todayObj.month, todayObj.day, "-"),
            tomorrowDate = formatDate(tomorrowObj.year, tomorrowObj.month, tomorrowObj.day, "-");
        }
      }
      var start = startObj.year * 12 + startObj.month,
        end = endObj.year * 12 + endObj.month,
        year = startObj.year,
        month = startObj.month;
      while (start <= end) {
        beCalendar(year, month);
        month++;
        if (month > 12) {
          month = 1;
          year++;
        }
        start++;
      }
      if (ticket.type == 8) {
        //酒店日历，今日以前和最后一天的日历置灰
        for (i = 0; i < todayIndex; i++) {
          ticket.alldayList[i].isBook = -1;
        }
        ticket.alldayList[ticket.alldayList.length - 1].isBook = -1;
      }
      return monthList;

      //生成一个月的日历
      function beCalendar(year, month) {
        var dayList = [];
        for (var i = 1; i <= new Date(year, month, 0).getDate(); i++) {
          var sellDate = formatDate(year, month, i, "-");
          if (index < useDate.length && sellDate == useDate[index].sellDate) {
            useDate[index].index = count;
            useDate[index].holiday = getHoliday(sellDate);
            dayList.push(useDate[index]);
            index++;
          } else {
            dayList.push({
              index: count,
              sellDate: sellDate,
              price: 0,
              stockNum: -1,
              dateStr: function () {
                if (ticket.type == 6) {
                  return "";
                }
                if (!isHasToday) {
                  if (sellDate == todayDate) {
                    todayIndex = count;
                    return "今日";
                  }
                  if (sellDate == tomorrowDate) {
                    return "明日";
                  }
                }
                switch (new Date(sellDate).getDay()) {
                  case 0:
                    return "周日";
                  case 1:
                    return "周一";
                  case 2:
                    return "周二";
                  case 3:
                    return "周三";
                  case 4:
                    return "周四";
                  case 5:
                    return "周五";
                  case 6:
                    return "周六";
                }
              }(),
              isBook: ticket.type == 8 ? 1 : -1,
              holiday: getHoliday(sellDate)
            });
          }
          count++;
        }
        ticket.alldayList instanceof Array && (ticket.alldayList = ticket.alldayList.concat(dayList));
        monthList.push(dayList);
      }

      //获取日期对象
      function getDateObj(str) {
        var date = new Date();
        if (str) {
          date = new Date(str);
        }
        return {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate()
        };
      }

      //格式化日期
      function formatDate(year, month, day, str) {
        var y = year;
        var m = month;
        if (m < 10) m = "0" + m;
        var d = day;
        if (d < 10) d = "0" + d;
        return y + str + m + str + d;
      }

      //返回节日，sellDate：yyyy-mm-dd
      function getHoliday(sellDate) {
        if (!sellDate || typeof sellDate != "string") return ""; //错误数据返回""
        var holidayList = [
        //节假日
        //公历
        {
          name: "元旦",
          date: "01-01"
        }, {
          name: "情人节",
          date: "02-14"
        }, {
          name: "妇女节",
          date: "03-08"
        }, {
          name: "植树节",
          date: "03-12"
        }, {
          name: "愚人节",
          date: "04-01"
        }, {
          name: "劳动节",
          date: "05-01"
        }, {
          name: "青年节",
          date: "05-04"
        }, {
          name: "儿童节",
          date: "06-01"
        }, {
          name: "建党节",
          date: "07-01"
        }, {
          name: "建军节",
          date: "08-01"
        }, {
          name: "教师节",
          date: "09-10"
        }, {
          name: "国庆节",
          date: "10-01"
        }, {
          name: "万圣节",
          date: "11-01"
        }, {
          name: "光棍节",
          date: "11-11"
        }, {
          name: "圣诞节",
          date: "12-25"
        },
        //农历
        {
          name: "除夕",
          lunar: "腊月三十"
        }, {
          name: "春节",
          lunar: "正月初一"
        }, {
          name: "元宵节",
          lunar: "正月十五"
        }, {
          name: "端午节",
          lunar: "五月初五"
        }, {
          name: "七夕节",
          lunar: "七月初七"
        }, {
          name: "中秋节",
          lunar: "八月十五"
        }, {
          name: "重阳节",
          lunar: "九月初九"
        }];
        var month_day = sellDate.replace(/\d{4}-/, ""),
          //月日：mm-dd
          lunarDay = getLunarDate(sellDate); //农历
        for (var i in holidayList) {
          //固定日期（国际、农历）节假日
          if (holidayList[i].date && holidayList[i].date == month_day) {
            return holidayList[i].name;
          }
          if (holidayList[i].lunar && holidayList[i].lunar == lunarDay) {
            return holidayList[i].name;
          }
        }
        var dateArr = sellDate.split("-"),
          year = +dateArr[0],
          //年
          month = +dateArr[1],
          //月
          day = +dateArr[2],
          //日
          firstWeekDay = new Date(sellDate.replace(/(\d{4}-\d{2}-)(\d{2})/, "$101")).getDay(); //月第一天周几

        if (month == 5) {
          //母亲节
          if (day == (firstWeekDay == 0 ? 8 : 15) - firstWeekDay) {
            return "母亲节";
          }
        }
        if (month == 6) {
          //父亲节
          if (day == (firstWeekDay == 0 ? 15 : 22) - firstWeekDay) {
            return "父亲节";
          }
        }
        return getSolarTerms(year, month, day);

        //获取yyyy-mm-dd农历日期
        function getLunarDate(sellDate) {
          var oDate1 = sellDate.split("-");
          var solarYear = oDate1[0];
          var solarMonth = oDate1[1];
          var solarDay = oDate1[2];
          var CalendarData = new Array(100);
          var madd = new Array(12);
          // var tgString = "甲乙丙丁戊己庚辛壬癸";
          // var dzString = "子丑寅卯辰巳午未申酉戌亥";
          var numString = "一二三四五六七八九十";
          var monString = "正二三四五六七八九十冬腊";
          // var weekString = "日一二三四五六";
          // var sx = "鼠牛虎兔龙蛇马羊猴鸡狗猪";
          var cMonth,
            // cYear,
            cDay, TheDate;
          CalendarData = new Array(0xa4b, 0x5164b, 0x6a5, 0x6d4, 0x415b5, 0x2b6, 0x957, 0x2092f, 0x497, 0x60c96, 0xd4a, 0xea5, 0x50da9, 0x5ad, 0x2b6, 0x3126e, 0x92e, 0x7192d, 0xc95, 0xd4a, 0x61b4a, 0xb55, 0x56a, 0x4155b, 0x25d, 0x92d, 0x2192b, 0xa95, 0x71695, 0x6ca, 0xb55, 0x50ab5, 0x4da, 0xa5b, 0x30a57, 0x52b, 0x8152a, 0xe95, 0x6aa, 0x615aa, 0xab5, 0x4b6, 0x414ae, 0xa57, 0x526, 0x31d26, 0xd95, 0x70b55, 0x56a, 0x96d, 0x5095d, 0x4ad, 0xa4d, 0x41a4d, 0xd25, 0x81aa5, 0xb54, 0xb6a, 0x612da, 0x95b, 0x49b, 0x41497, 0xa4b, 0xa164b, 0x6a5, 0x6d4, 0x615b4, 0xab6, 0x957, 0x5092f, 0x497, 0x64b, 0x30d4a, 0xea5, 0x80d65, 0x5ac, 0xab6, 0x5126d, 0x92e, 0xc96, 0x41a95, 0xd4a, 0xda5, 0x20b55, 0x56a, 0x7155b, 0x25d, 0x92d, 0x5192b, 0xa95, 0xb4a, 0x416aa, 0xad5, 0x90ab5, 0x4ba, 0xa5b, 0x60a57, 0x52b, 0xa93, 0x40e95);
          madd[0] = 0;
          madd[1] = 31;
          madd[2] = 59;
          madd[3] = 90;
          madd[4] = 120;
          madd[5] = 151;
          madd[6] = 181;
          madd[7] = 212;
          madd[8] = 243;
          madd[9] = 273;
          madd[10] = 304;
          madd[11] = 334;
          function GetBit(m, n) {
            return m >> n & 1;
          }
          function e2c() {
            TheDate = arguments.length != 3 ? new Date() : new Date(arguments[0], arguments[1], arguments[2]);
            var total, m, n, k;
            var isEnd = false;
            var tmp = TheDate.getYear();
            if (tmp < 1900) {
              tmp += 1900;
            }
            total = (tmp - 1921) * 365 + Math.floor((tmp - 1921) / 4) + madd[TheDate.getMonth()] + TheDate.getDate() - 38;
            if (TheDate.getYear() % 4 == 0 && TheDate.getMonth() > 1) {
              total++;
            }
            for (m = 0;; m++) {
              k = CalendarData[m] < 0xfff ? 11 : 12;
              for (n = k; n >= 0; n--) {
                if (total <= 29 + GetBit(CalendarData[m], n)) {
                  isEnd = true;
                  break;
                }
                total = total - 29 - GetBit(CalendarData[m], n);
              }
              if (isEnd) break;
            }
            // cYear = 1921 + m;
            cMonth = k - n + 1;
            cDay = total;
            if (k == 12) {
              if (cMonth == Math.floor(CalendarData[m] / 0x10000) + 1) {
                cMonth = 1 - cMonth;
              }
              if (cMonth > Math.floor(CalendarData[m] / 0x10000) + 1) {
                cMonth--;
              }
            }
          }
          function GetcDateString() {
            var tmp = "";
            // tmp += tgString.charAt((cYear - 4) % 10);
            // tmp += dzString.charAt((cYear - 4) % 12);
            // tmp += "(";
            // tmp += sx.charAt((cYear - 4) % 12);
            // tmp += ")年 ";
            if (cMonth < 1) {
              tmp += "(闰)";
              tmp += monString.charAt(-cMonth - 1);
            } else {
              tmp += monString.charAt(cMonth - 1);
            }
            tmp += "月";
            tmp += cDay < 11 ? "初" : cDay < 20 ? "十" : cDay < 30 ? "廿" : "三十";
            if (cDay % 10 != 0 || cDay == 10) {
              tmp += numString.charAt((cDay - 1) % 10);
            }
            return tmp;
          }
          if (solarYear < 1921 || solarYear > 2020) {
            return "";
          } else {
            solarMonth = parseInt(solarMonth) > 0 ? solarMonth - 1 : 11;
            e2c(solarYear, solarMonth, solarDay);
            return GetcDateString();
          }
        }

        //返回21世纪的二十四节气
        function getSolarTerms(year, month, day) {
          if (year >= 2100 || year < 2000) return ""; //不是21世纪的年份，返回空字符

          var lastTwo = year % 100,
            //年份后两位数
            _qm = 0; //寿星公式：[Y*D+C]-L，年数的后2位乘0.2422加C取整数减闰年数。
          function shouxingFormula(C) {
            return parseInt(lastTwo * 0.2422 + C) - parseInt(lastTwo / 4);
          }
          if (month == 1) {
            _qm = shouxingFormula(5.4055);
            if (day == (year == 2019 ? _qm - 1 : _qm)) {
              return "小寒";
            }
            _qm = shouxingFormula(20.12);
            if (day == (year == 2082 ? _qm + 1 : _qm)) {
              return "大寒";
            }
          }
          if (month == 2) {
            _qm = shouxingFormula(3.87);
            if (day == _qm) {
              return "立春";
            }
            _qm = shouxingFormula(18.73);
            if (day == (year == 2026 ? _qm - 1 : _qm)) {
              return "雨水";
            }
          }
          if (month == 3) {
            _qm = shouxingFormula(5.63);
            if (day == _qm) {
              return "惊蛰";
            }
            _qm = shouxingFormula(20.646);
            if (day == (year == 2084 ? _qm + 1 : _qm)) {
              return "春分";
            }
          }
          if (month == 4) {
            _qm = shouxingFormula(4.81);
            if (day == _qm) {
              return "清明节";
            }
            _qm = shouxingFormula(20.1);
            if (day == _qm) {
              return "谷雨";
            }
          }
          if (month == 5) {
            _qm = shouxingFormula(5.52);
            if (day == _qm) {
              return "立夏";
            }
            _qm = shouxingFormula(21.04);
            if (day == (year == 2008 ? _qm + 1 : _qm)) {
              return "小满";
            }
          }
          if (month == 6) {
            _qm = shouxingFormula(5.678);
            if (day == _qm) {
              return "芒种";
            }
            _qm = shouxingFormula(21.37);
            if (day == _qm) {
              return "夏至";
            }
          }
          if (month == 7) {
            _qm = shouxingFormula(7.108);
            if (day == (year == 2016 ? _qm + 1 : _qm)) {
              return "小暑";
            }
            _qm = shouxingFormula(22.83);
            if (day == _qm) {
              return "大暑";
            }
          }
          if (month == 8) {
            _qm = shouxingFormula(7.5);
            if (day == (year == 2002 ? _qm + 1 : _qm)) {
              return "立秋";
            }
            _qm = shouxingFormula(23.13);
            if (day == _qm) {
              return "处暑";
            }
          }
          if (month == 9) {
            _qm = shouxingFormula(7.646);
            if (day == _qm) {
              return "白露";
            }
            _qm = shouxingFormula(23.042);
            if (day == _qm) {
              return "秋分";
            }
          }
          if (month == 10) {
            _qm = shouxingFormula(8.318);
            if (day == _qm) {
              return "寒露";
            }
            _qm = shouxingFormula(23.438);
            if (day == (year == 2089 ? _qm + 1 : _qm)) {
              return "霜降";
            }
          }
          if (month == 11) {
            _qm = shouxingFormula(7.438);
            if (day == (year == 2089 ? _qm + 1 : _qm)) {
              return "立冬";
            }
            _qm = shouxingFormula(22.36);
            if (day == _qm) {
              return "小雪";
            }
          }
          if (month == 12) {
            _qm = shouxingFormula(7.18);
            if (day == _qm) {
              return "大雪";
            }
            _qm = shouxingFormula(21.94);
            if (day == (year == 2021 ? _qm - 1 : _qm)) {
              return "冬至";
            }
          }
          return "";
        }
      }
    }
  }
};